<template>
  <div>
    <app-header title="PHP Status" />
    <div class="container container-fluid mt-4 mb-4">

        <div class="page-heading">

            <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col d-flex align-items-center">
                      <h2 class="mb-2">PHP Status</h2>
                    </div>
                    <div v-html="info"></div>
                  </div>
                  
                </div>
                
            </div>

            
        </div><!-- /.page-heading -->

    </div><!-- /.wrapper -->
  </div>
</template>

<script>

    import { http } from 'utils'

    export default {

        data: function () {
            return {
                info: null,
            }
        },

        mounted() {

            http.get('/phpstatus').then((response) => {
              this.info = response.data.info
            }).catch(function (error) {
                if (error.response && error.response.status) {
                    notify.error("API Error: " + error.response.status + " <br> " + error.response.statusText)
                }
            });
        }
    }
</script>
